import { render, staticRenderFns } from "./KnProductBackorders.vue?vue&type=template&id=78388f14"
import script from "./KnProductBackorders.js?vue&type=script&lang=js&external"
export * from "./KnProductBackorders.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports